import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { workClient } from "../clients/workClient";

const documentCategoriesSchema = z.array(
  z.object({
    id: z.number().int().positive(),
    name: z.string(),
  }),
);

export async function fetchDocumentCategories(
  customerId: string,
  facilityId: string,
) {
  const response = await workClient.v1.customers[":customerId"].facilities[
    ":facilityId"
  ].documents.categories.$get({ param: { customerId, facilityId } });
  if (!response.ok)
    throw new Error(`Failed to fetch categories: ${response.status}`);
  return documentCategoriesSchema.parse(await response.json());
}

export function useDocumentCategories(
  customerId: string,
  facilityId: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["document-categories", customerId, facilityId],
    queryFn: () => fetchDocumentCategories(customerId, facilityId),
    enabled: enabled && !!customerId && !!facilityId,
    meta: { errorMessage: "Failed to load categories" },
  });
}
